import { FLAGSHIP_ORG } from '@/lib/moduleAccess';

// ── Whose name goes at the top of a sign-in page ─────────────────────────────
// Decided the same way as everywhere else (useOrgBranding gives the brand):
// the tenant's, where the host or the session says whose portal this is;
// Parcelink's on Parcelink's own hosts; and neutral Runmark on the shared
// tenant host, which cannot know. The sign-in chrome used to hard-code
// Parcelink's logo and "Crew Portal", so a Runmark customer met Parcelink's
// mark at the one moment brand matters (owner, 8 Oct 2026: "Parcelink should
// be for Parcelink only").
export function headerIdentity(brand, onRunmarkHost) {
  if (!brand?.org_key && onRunmarkHost) return { kind: 'runmark' };
  if (brand?.org_key === FLAGSHIP_ORG) {
    return { kind: 'logo', src: brand.logo || '/logo.png?v=3', title: 'Crew Portal', subtitle: 'Operations platform' };
  }
  const title = brand?.name || brand?.wordmark || 'Runmark';
  if (brand?.logo) return { kind: 'logo', src: brand.logo, title, subtitle: 'Operations platform' };
  return { kind: 'text', title, subtitle: 'Operations platform' };
}
